import * as React from "react";
const SvgFiRrMessageSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-message-slash_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-3.187-3.187A4 4 0 0 0 22 16V6c0-2.206-1.794-4-4-4H6a4 4 0 0 0-2.032.554L1.708.294A.999.999 0 1 0 .292 1.706l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M6 4h12c1.103 0 2 .897 2 2v10c0 .685-.352 1.313-.909 1.677L5.482 4.068A2 2 0 0 1 6 4m9.483 15.363a1 1 0 0 1-.134 1.407l-2.169 1.793a1.75 1.75 0 0 1-1.172.44 1.83 1.83 0 0 1-1.218-.464L7.774 20H6c-2.206 0-4-1.794-4-4V9a1 1 0 1 1 2 0v7c0 1.103.897 2 2 2H8.14c.235 0 .464.083.645.235l3.216 2.71 2.075-1.716a1 1 0 0 1 1.407.134z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-message-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMessageSlash;
